import React, { FC, Fragment } from "react";
import Logo from "shared/Logo/Logo";
import Navigation from "shared/Navigation/Navigation";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import MenuBar from "shared/MenuBar/MenuBar";
import { logOut } from "functions/redux/user/action";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import Button from "shared/Button/Button";
import NcModal from "shared/NcModal/NcModal";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { Menu, Transition } from '@headlessui/react'
import { getNotification } from "functions/redux/notification/action";
import { authJsonPost } from "functions/BaseAxios";
import moment from "moment";

export interface MainNav1Props {
  isTop: boolean;
  credential: User;
  notification: any;
  count: any
}



const MainNav1: FC<MainNav1Props> = ({ isTop, credential, notification, count }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [showConfirmation, setShowConfirmation] = React.useState(false);


  const logout = async () => {
    await dispatch(logOut());
    await dispatch(getNotification());
    history.replace('/')
  }

  return (
    <div
      className={`nc-MainNav1 relative z-10 ${isTop ? "onTop " : "notOnTop backdrop-filter"
        }`}
    >
      <NcModal
        isOpenProp={showConfirmation}
        renderTrigger={() => { return (<div></div>); }}
        renderContent={() => {
          return (
            <div className="max-w-md">
              <p className="text-center font-regular ">
                {t('logout_confirm')}
              </p>
              <div className="flex justify-center space-x-5 mt-8">
                <ButtonSecondary onClick={() => setShowConfirmation(false)} >{t('no')}</ButtonSecondary>
                <ButtonPrimary onClick={() => {
                  setShowConfirmation(false);
                  logout();
                }}
                >{t('yes')}
                </ButtonPrimary>
              </div>
            </div>
          )
        }}
        hideCloseBtn={true}
        // contentExtraClass="w-1/4"
        modalTitle={t('logout')}
      />
      <div className="container py-5 relative flex justify-between items-center space-x-4 md:space-x-8">
        <div className="flex justify-start flex-grow items-center space-x-4 sm:space-x-10 2xl:space-x-14">
          <Logo />
          <Navigation credential={credential} />
        </div>
        <div className="flex-shrink-0 flex items-center justify-end text-neutral-700 dark:text-neutral-100 space-x-1">
          <div className="hidden items-center md:flex space-x-1">
            <div className="px-1" />
            {credential == null ? <div></div> : credential.profile != null ?
              <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'row' }}>
                {/* <NcDropDown data={[{ id: '1', name: `${t('delete')} ${t('answer')}`, icon: "" }]} onClick={() => {

                }} /> */}
                <DropdownNotif notification={notification} credential={credential} count={count} />
                <ButtonPrimary href="/profile">{credential.profile?.displayName}</ButtonPrimary>
                <Button onClick={() => setShowConfirmation(true)} className="ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-neutral-50 ml-2"><i className="la la-sign-out" style={{ fontSize: 22 }}></i></Button>
              </div>
              :
              <ButtonPrimary href="/login">{t('sign_up')}</ButtonPrimary>
            }
          </div>
          <div className="flex items-center md:hidden">
            {credential == null ? <div></div> : credential.profile != null ?
              <DropdownNotif notification={notification} credential={credential} count={count} />
              : <></>}
            <MenuBar credential={credential} />
          </div>
        </div>
      </div>
    </div>
  );
};

const DropdownNotif: FC<{ notification: any, count: any, credential: User }> = ({ notification, count, credential }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const getCount = () => {
    let data: any = [];
    if (notification) {
      notification.findIndex((o: any, index: any) => {
        if (o.status == 0) {
          data.push(o)
        }

      })
    }
    return data.length;
  }


  const buttonLocation = async (type: any, identifier: any, notif: any) => {

    if (notif.status == 0) {
      let result = await authJsonPost({ id: notif.id }, 'auth/notification/update-read');

      dispatch(getNotification());
    }

    if (type == 'product') {
      if (notif.title == 'Question Product') {
        history.replace(`/profile?q=4`)
      } else {
        history.replace(`/detail?q=${notif.slugUrl}&t=${identifier}`)
      }
    } else if (type.includes('your_booked') || type.includes('new_booking') || type.includes('booking_accepted')) {
      history.replace(`booking-detail?id=${identifier}`)
    } else if (type == 'guide_approved') {
      history.replace(`/profile`)

    }
  }

  const seeAllNotif = () => {
    history.replace('/notification');
  }


  return (
    <div className="">
      <Menu as="div" className="relative inline-block text-left">
        <div>
          {credential && credential.profile != null && (
            <Menu.Button className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-primary-6000 rounded-md bg-opacity-20  focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
              <i className="las la-bell" style={{ fontSize: 30 }}></i>
              {count ? count > 0 ?
                (<div className="absolute inline-flex rounded-full  " style={{ top: 0, color: 'white', backgroundColor: 'red', marginLeft: 15 }}>
                  <span style={{ paddingRight: 2, paddingLeft: 2 }}>{count > 10 ? '10+' : count}</span>
                </div>) : <></> : <></>
              }
            </Menu.Button>
          )}
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 md:w-96 w-72  mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" >
            <div style={{ overflowY: 'auto', maxHeight: '70vh' }}>
              {notification ? notification.length > 0 ? notification.map((val: any, key: any) => {

                let date = new Date();
                let offset = date.getTimezoneOffset();
                let dateAnswer = moment(Date.parse(val.createdAt)).add((offset * (-1)), 'm').toNow();

                return (
                  <div key={val.id} className="px-1 py-1 ">
                    <Menu.Item key={val.id}>
                      {({ active }) => (
                        <button
                          className={`${active ? 'bg-primary-50 text-white' : 'text-gray-900'
                            } group flex rounded-md text-left  w-full px-2 py-2 text-sm ${val.status == 0 && active == false ? 'bg-neutral-100' : ''} `}
                          onClick={() => {
                            buttonLocation(val.slug, val.identifier, val)
                          }}
                        >
                          <div>
                            <div className="flex justify-between">
                              <label style={{ fontWeight: 'bold' }}>{val.title}</label>
                              <label>{dateAnswer}</label>
                            </div>
                            <p>{val.text}</p>
                          </div>
                        </button>
                      )}
                    </Menu.Item>
                  </div>
                )

              }) : <div className="px-1 py-1 "><Menu.Item>
                <p className="text-center">No Notification</p>
              </Menu.Item> </div>
                : <div className="px-1 py-1 "><Menu.Item>
                  <p className="text-center">No Notification</p>
                </Menu.Item> </div>}
            </div>
            <Menu.Item key={20}>
              {({ active }) => (
                <a onClick={() => {
                  seeAllNotif()
                }} className={`${active ? 'bg-primary-50 text-white text-center cursor-pointer' : 'text-gray-900'
                  } group flex rounded-md  w-full px-2 py-2 text-sm  justify-center`}><p className="text-center">Show All Notification</p></a>
              )}
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  )
}

export default MainNav1;